export const COLOR_PALETTE_COLUMNS = 12;

export const COLOR_PALETTE: readonly string[] = [
  '#000000', '#171717', '#2E2E2E', '#454545', '#5D5D5D', '#747474', '#8B8B8B', '#A2A2A2', '#B9B9B9', '#D1D1D1', '#E8E8E8', '#FFFFFF',
  '#EC1313', '#EC8013', '#ECEC13', '#80EC13', '#13EC13', '#13EC80', '#13ECEC', '#1380EC', '#1313EC', '#8013EC', '#EC13EC', '#EC1380',
  '#FBD0D0', '#FBE6D0', '#FBFBD0', '#E6FBD0', '#D0FBD0', '#D0FBE6', '#D0FBFB', '#D0E6FB', '#D0D0FB', '#E6D0FB', '#FBD0FB', '#FBD0E6',
  '#F79797', '#F7C797', '#F7F797', '#C7F797', '#97F797', '#97F7C7', '#97F7F7', '#97C7F7', '#9797F7', '#C797F7', '#F797F7', '#F797C7',
  '#F25A5A', '#F2A65A', '#F2F25A', '#A6F25A', '#5AF25A', '#5AF2A6', '#5AF2F2', '#5AA6F2', '#5A5AF2', '#A65AF2', '#F25AF2', '#F25AA6',
  '#BD0F0F', '#BD660F', '#BDBD0F', '#66BD0F', '#0FBD0F', '#0FBD66', '#0FBDBD', '#0F66BD', '#0F0FBD', '#660FBD', '#BD0FBD', '#BD0F66',
  '#8E0B0B', '#8E4D0B', '#8E8E0B', '#4D8E0B', '#0B8E0B', '#0B8E4D', '#0B8E8E', '#0B4D8E', '#0B0B8E', '#4D0B8E', '#8E0B8E', '#8E0B4D',
  '#5E0808', '#5E3308', '#5E5E08', '#335E08', '#085E08', '#085E33', '#085E5E', '#08335E', '#08085E', '#33085E', '#5E085E', '#5E0833',
];

export type ColorPaletteSection = {
  key: string;
  start: number;
  count: number;
};

export const COLOR_PALETTE_SECTIONS: readonly ColorPaletteSection[] = [
  { key: 'neutral', start: 0, count: 12 },
  { key: 'hue', start: 12, count: 12 },
  { key: 'shade', start: 24, count: 72 },
];

function withHashPrefix(value: string): string {
  if (value.charAt(0) === '#') {
    return value;
  }
  return '#' + value;
}

export function normalizeColorHex(value: string): string {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed !== '') {
      const upper = withHashPrefix(trimmed).toUpperCase();
      if (/^#[0-9A-F]{6}$/.test(upper)) {
        return upper;
      }
    }
  }
  return '';
}

export function findColorPaletteIndex(value: string): number {
  const normalized = normalizeColorHex(value);
  if (normalized !== '') {
    return COLOR_PALETTE.indexOf(normalized);
  }
  return -1;
}
